import { Link } from "react-router-dom";
import Seo from "../lib/seo";

export default function NotFound() {
  return (
    <main data-testid="notfound-page" className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 pt-52 pb-40 min-h-[60vh]">
      <Seo title="Not found — RCKT" noindex />
      <div className="label mb-6">Error 404</div>
      <h1 className="font-display font-800 uppercase leading-[0.9] tracking-[-0.02em] text-6xl md:text-8xl">Lost mark.</h1>
      <p className="mt-8 text-[var(--muted)] max-w-md">The page you're looking for isn't part of the archive.</p>
      <Link to="/archive" className="group inline-flex items-center gap-3 font-display uppercase tracking-[0.12em] text-sm mt-12">
        <span className="border-b border-transparent group-hover:border-[var(--ink)] transition-colors pb-1">Enter the Archive</span>
        <span className="transition-transform duration-300 group-hover:translate-x-1.5">→</span>
      </Link>
    </main>
  );
}
